<div class="grid gap-4 sm:grid-cols-[1fr_auto]">
  <div class="space-y-4">
    <div class="space-y-1">
      <span hlmLabel>Format</span>
      <div class="flex flex-wrap gap-2">
        @for (preset of presets(); track preset.key) {
          <button
            hlmBtn
            size="sm"
            type="button"
            [variant]="activePreset() === preset.key ? 'default' : 'outline'"
            [attr.title]="preset.width_mm + ' × ' + preset.height_mm + ' mm'"
            (click)="usePreset(preset)">
            {{ preset.label }}
          </button>
        }
      </div>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div class="space-y-1">
        <label hlmLabel for="blank-w">Breite (mm)</label>
        <input
          hlmInput
          id="blank-w"
          type="number"
          [min]="minSide"
          [max]="maxSide"
          step="1"
          [value]="page().width_mm"
          (change)="onSide('width_mm', $event)" />
      </div>
      <div class="space-y-1">
        <label hlmLabel for="blank-h">Höhe (mm)</label>
        <input
          hlmInput
          id="blank-h"
          type="number"
          [min]="minSide"
          [max]="maxSide"
          step="1"
          [value]="page().height_mm"
          (change)="onSide('height_mm', $event)" />
      </div>
    </div>

    <div class="space-y-1">
      <span hlmLabel>Ausrichtung</span>
      <div class="flex gap-2" role="group" aria-label="Ausrichtung">
        <button
          hlmBtn
          size="sm"
          type="button"
          [variant]="!page().landscape ? 'default' : 'outline'"
          [attr.aria-pressed]="!page().landscape"
          (click)="setLandscape(false)">
          Hochformat
        </button>
        <button
          hlmBtn
          size="sm"
          type="button"
          [variant]="page().landscape ? 'default' : 'outline'"
          [attr.aria-pressed]="page().landscape"
          (click)="setLandscape(true)">
          Querformat
        </button>
      </div>
    </div>

    <div class="space-y-1">
      <label hlmLabel for="blank-color">Seitenfarbe</label>
      <div class="flex items-center gap-2">
        <input
          type="color"
          class="size-8 cursor-pointer rounded border-none bg-transparent p-0"
          aria-label="Seitenfarbe wählen"
          [value]="page().background_color"
          (input)="onColor($event)" />
        <input
          hlmInput
          id="blank-color"
          type="text"
          maxlength="7"
          class="max-w-32"
          [value]="page().background_color"
          (change)="onColor($event)" />
      </div>
    </div>

    @if (!valid()) {
      <p class="text-destructive text-sm">
        Jede Seite muss zwischen {{ minSide }} und {{ maxSide }} mm liegen, die Farbe ein Hex-Wert
        wie #FFFFFF sein.
      </p>
    }
  </div>

  <div class="flex flex-col items-center gap-2">
    <div class="rounded border shadow-sm" [style]="previewStyle()" aria-hidden="true"></div>
    <p hlmMuted class="text-xs">{{ printed().width }} × {{ printed().height }} mm</p>
  </div>
</div>
